<app-header></app-header>

<!-- <main role="main" class="flex-shrink-0">
    <div class="container-fluid mt-5 mb-4"> -->
      <!-- <div class="container" style="float:left;" > -->
    <ngx-spinner></ngx-spinner>  
    <div class="row pb-2 mt-4 ml-1 mr-1">
        <div class="col">
            <h4>
                <div>{{ CreateShowHide ? 'Add Print Group' : UpdateShowHide ? 'Edit Print Group': 'Print Groups'}}</div>
            </h4>
        </div>
    </div>
    <div class="row mb-2 ml-1 mr-1">
        <div class="col">
          <button type="button" *ngIf="AddShowHide" (click)="AddPrintGroup()" class="btn btn-success float-right">
            <i class="fas fa-plus-circle"></i> <span>Add Print Group</span>
          </button>
        </div>
      </div>
    <form [formGroup]="frmPrintGroup" *ngIf="CreateShowHide || UpdateShowHide">
        <div class="row ml-1 mr-1">
            <div class="col">
                <div class="form-row">
                    <div class="form-group col-lg-4">
                        <label for="txtPrintGroup">Print Group</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtPrintGroup" formControlName="PrintGroup" required *ngIf="CreateShowHide === false "readonly="readonly">
                        <input type="text" class="form-control" id="txtPrintGroup" formControlName="PrintGroup" required *ngIf="CreateShowHide === true">
                        <input type="text" class="form-control" id="txtPrintGroupImageName" formControlName="PrintGroupImageName" hidden>
                    </div>
                    <div class="form-group col-lg-3">
                        <label for="txtDesignName">Design name</label><span style="color:red;">&nbsp;*</span>
                        <input type="text" class="form-control" id="txtDesignName" formControlName="DesignName" required>
                    </div>
                </div>
            </div>
        </div>

        <div class="row ml-1 mr-1">
            <div class="col">
              <div class="form-row">
                <div class="form-group col-lg-8">
                  <button type="button" class="btn btn-success" (click)="fileInput.click()" >Choose File</button><span style="color:red;"> *</span>
                  <input  hidden #fileInput type="file" accept=".jpg" id="file" formControlName="PrintGroupImage" (change)="setFilename(fileInput.files)" />
                  <label >{{ this.filename }}</label>                  
                  <img *ngIf="isShown" src="{{this.baseUrl + this.printgroupnameimg}}" style="max-width:20%; height: auto;" alt="{{this.printgroupnameimg}}" title="{{this.printgroupnameimg}}">
                </div>
                 <div *ngIf="frmPrintGroup.get('PrintGroupImage').invalid && frmPrintGroup.get('PrintGroupImage').touched"  class="validation">
                  <small *ngIf="frmPrintGroup.get('PrintGroupImage').errors.required">
                    Must be required!!!
                  </small>                  
                </div> 
              </div>
            </div>
          </div>

        <div class="row ml-1 mr-1">
            <div class="col">
                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreatePrintGroup(fileInput.files)">
                    <i class="fas fa-pen" area-hidden="true"></i> <span class="d-none d-md-inline d-lg-inline">Submit</span>
                </button>
                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdatePrintGroup(fileInput.files)">
                    <i class="fas fa-pen" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Update</span>
                </button>
                <a>
                    <button type="button" aria-controls="addPrintGroup"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">
                        <i class="fas fa-undo" area-hiddeb="true"></i> <span class="d-none d-md-inline d-lg-inline">Cancel</span>
                    </button>
                </a>    
            </div>
        </div>
    </form>
    <!-- <div id="addPrintGroup"tabindex="-1" #addPrintGroup aria-labelledby="addPrintGroup"aria-hidden="true" *ngIf="CreateShowHide || UpdateShowHide">
        <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="addPrintGroup">Edit Print Group Information</h5>
              </div>
                <div class="modal-body">
                    <form [formGroup]="frmPrintGroup">
                        <div class="form-row">
                          <div class="form-group col-lg-4">

                                <label for="txtPrintGroup">Print Group</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtPrintGroup"
                                formControlName="PrintGroup" required *ngIf="CreateShowHide === false "readonly="readonly">
                                <input type="text" class="form-control" id="txtPrintGroup"
                                formControlName="PrintGroup" required *ngIf="CreateShowHide === true">
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="txtDesignName">Design name</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtDesignName"
                                formControlName="DesignName"  required>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                              <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreatePrintGroup()">Add</button>
                                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide" (click)="UpdatePrintGroup()">Update</button>
                              </div>
                              <div class="col-md-6">
                                <button type="button" aria-controls="addPrintGroup"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary">Cancel</button>
                            </div>
                        </div>
                      </div>
                    </form>
                </div>
            </div>

        </div>
    </div> -->
    <div class="row ml-1 mr-1" *ngIf="!(CreateShowHide || UpdateShowHide)">
        <div class="col">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" *ngIf="EditShowHide">Actions</th>
                            <th scope="col">Print Group <span (click)="SortOder('PrintGroup1')"><i class="fas fa-sort"></i></span></th>
                            <th scope="col">Design Name <span (click)="SortOder('DesignName')"><i class="fas fa-sort"></i></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | paginate: config ">
                            <td *ngIf="EditShowHide">
                              <table>
                                <tr>
                                  <td>
                                    <button type="button" class="btn btn-info btn-sm"
                                            (click)="EditPrintGroup(item)" title="Edit">
                                      <i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                                    </button>
                                  </td>
                                  <td>
                                    <button class="btn btn-info btn-sm" (click)="DeletePrintGroup(item.Id)" title="Delete">
                                      <i class="far fa-trash-alt fa-lg text-danger"></i>
                                      <span class="d-none d-md-inline d-lg-inline">Delete</span>
                                    </button>
                                  </td>
                                </tr>
                              </table>                                
                            </td>
                            <td >{{item.PrintGroup1}}</td>
                            <td>{{item.DesignName}}</td>

                        </tr>
                        <tr>
                            <td colspan="7" style="text-align: right;">
                                <pagination-controls (pageChange)="pageChanged($event)" id="Printgroup"></pagination-controls>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div>


    <!-- <div class="row mb-2">
        <div class="col">

        </div>
    </div>
    <div class="modal fade" id="addPrintGroup"tabindex="-1" #addPrintGroup aria-labelledby="addPrintGroup"aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role=document>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="addPrintGroup">Enter Print Group Information</h5>
                <button type="button" class="close" data-dismiss="modal" (click)="Cancel()" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
                <div class="modal-body">
                    <form [formGroup]="frmPrintGroup">
                        <div class="form-row">
                          <div class="form-group col-lg-4">

                                <label for="txtPrintGroup">Print Group</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtPrintGroup"
                                formControlName="PrintGroup" required *ngIf="CreateShowHide === false "readonly="readonly">
                                <input type="text" class="form-control" id="txtPrintGroup"
                                formControlName="PrintGroup" required *ngIf="CreateShowHide === true">
                            </div>
                            <div class="form-group col-lg-4">
                                <label for="txtDesignName">Design name</label><span style="color:red;">&nbsp;*</span>
                                <input type="text" class="form-control" id="txtDesignName"
                                formControlName="DesignName"  required>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="row">
                              <div class="col-md-6">
                                <button type="button" class="btn btn-success" *ngIf="CreateShowHide" (click)="CreatePrintGroup()">Add</button>
                                <button type="button" class="btn btn-success" *ngIf="UpdateShowHide"data-toggle="modal" data-dismiss="modal" (click)="UpdatePrintGroup()">Update</button>
                              </div>
                              <div class="col-md-6">
                                <button type="button" data-target="#addPrintGroup" data-toggle="modal" aria-controls="addPrintGroup"  *ngIf="CancelShowHide" (click)="Cancel()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            </div>
                        </div>
                      </div>
                    </form>
                </div>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="table-responsive">
                <table class="table table-striped table-bordered table-hover table-sm">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col" *ngIf="EditShowHide">Actions</th>
                            <th scope="col">Print Group <span (click)="SortOder('PrintGroup1')"><i class="fas fa-sort"></i></span></th>
                            <th scope="col">Design Name <span (click)="SortOder('DesignName')"><i class="fas fa-sort"></i></span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items | paginate: config ">
                            <td *ngIf="EditShowHide">
                                <button type="button"  data-target="#addPrintGroup" data-toggle="modal" class="btn btn-info btn-sm"
                                (click)="EditPrintGroup(item)" title="Edit"><i class="fas fa-pen"></i> <span class="d-none d-md-inline d-lg-inline">Edit</span>
                                </button>
                            </td>
                            <td >{{item.PrintGroup1}}</td>
                            <td>{{item.DesignName}}</td>

                        </tr>
                        <tr>
                            <td colspan="7" style="text-align: right;">
                                <pagination-controls (pageChange)="pageChanged($event)" id="Printgroup"></pagination-controls>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
    </div> -->
    <!-- </div> -->
<!-- </div>
</main> -->
